/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * The call type:
 *   * INTERPHONE
 *   * TELEPHONE
 *   * SMS
 *   * OTHER
 */
export enum CallType {
  INTERPHONE = 'INTERPHONE',
  TELEPHONE = 'TELEPHONE',
  SMS = 'SMS',
  OTHER = 'OTHER'
}
